import React, { useState } from 'react';
const ImageSlider = props => {
  const [active, setActive] = useState(0);
  const changeActive = e => {
    e.target.parentNode.querySelectorAll('.option').forEach(el => {
      el.classList.remove('active');
    });
    if (e.target.getAttribute('data-id') != active) {
      e.target.classList.add('active');
      setActive(e.target.getAttribute('data-id'));
    } else {
      setActive(-1);
      e.target.classList.remove('active');
    }
  };
  const slides = [
    {
      icon: '/images/design/desktoppen.svg',
      title: 'Dr. Smith Doe',
      subtitle: 'Website Design',
      image: '/images/about/1.jpg',
    },
    {
      icon: '/images/design/desktoppen.svg',
      title: 'Arara Tour',
      subtitle: 'Website Design',
      image: '/images/about/2.jpg',
    },
    {
      icon: '/images/design/image.svg',
      title: 'SoftLand',
      subtitle: 'Website Design',
      image: '/images/about/3.jpg',
    },
    {
      icon: '/images/design/desktop1.svg',
      title: 'Tutor Plus',
      subtitle: 'Website Design',
      image: '/images/about/4.jpg',
    },
    {
      icon: '/images/design/mobile.svg',
      title: 'Investing App ',
      subtitle: 'App Design',
      image: '/images/about/5.jpg',
    },
    {
      icon: '/images/design/mobile.svg',
      title: 'House Mates1',
      subtitle: 'App Design',
      image: '/images/about/7.jpg',
    },
    {
      icon: '/images/design/mobile.svg',
      title: 'House Mates2',
      subtitle: 'App Design',
      image: '/images/about/11.jpg',
    },
  ];
  return (
    <>
      <div className="options mt-10">
        <style jsx global>
          {`
            .options .option.active::after {
              content: unset;
            }

            .options {
              display: flex;
              flex-direction: row;
              align-items: stretch;
              overflow: hidden;
              width: 100%;
              height: 411px;
            }

            .options .option {
              position: relative;
              overflow: hidden;
              min-width: 100px;
              margin: 10px;
              cursor: pointer;
              border-radius: 5px;
              background-size: cover !important;
              background-repeat: no-repeat !important;
              background-position: center !important;
              flex-grow: 1;
              -webkit-transition: all 2s linear;
              transition: all 2s linear;
            }
            .options .option:first-child {
              margin-left: 0px;
            }
            .options .option.active {
              flex-grow: 10000;
              transition: all 2s linear;
            }
            .options .option:not(.active) {
              flex-grow: 1;
              -webkit-transition: all 2s linear;
              transition: all 2s linear;
            }
            @media screen and (max-width: 1000px) {
              .options {
                flex-direction: column;
                height: auto;
              }
              .option {
                min-height: 71px;
                height: 100px;
                margin: 10px 0 !important;
              }
              .options .option.active {
                height: 300px;
                -webkit-transition: all 0.5s linear;
                transition: all 0.5s linear;
              }
            }
          `}
        </style>
        {slides &&
          slides.map((s, i) => {
            return (
              <div className={`option`} onClick={e => changeActive(e)} style={{ backgroundImage: `url('${s.image}')` }} key={s.title} data-id={i}>
                <div className="shadow" />
              </div>
            );
          })}
      </div>
    </>
  );
};
export default ImageSlider;
